<template>
  <div class="col-12">
    <!-- <div class="col-12" style="margin-top: 10px">
      <h4 style="color: blue">Farmer Dashboard</h4>
      <hr />
    </div> -->

    <div class="col-12" style="margin-top: 10px">
      <b><h3>
        My Animals
        <b-btn
          class="btn-success float-right"
          style="text-align: right"
          @click="add()"
        >
         <b> + </b> </b-btn
        >&nbsp;
        <b-btn
          class="btn-danger float-right"
          style="text-align: right; margin-right: 5px"
          @click="back()"
        >
          <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill> Back
        </b-btn>
      </h3></b>
      <hr />
    </div>
    <div class="row" style="margin: 0px">
      <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6">
        <b-card style="max-width: 20rem" class="mb-2">
          <b-card-text @click="handleDetails">
            <div class="container ">
              <img
              class=""
                src="../assets/114.jpg"
                style="width:150px;height:160px;object-fit: cover; padding-right: 20px"
              />
              <div class="centered ">
                <div class="row center_back">
                  <div
                    class="col-12 "
                    style="
                      font-family: Arial;
                      font-size: 18px;
                      padding: 5px;
                    "
                  >
                    <table>
                      <tr >
                        <td class="animalKattaDesc" style="font-size:20px;font-weight:bold;color:white">Cow</td> <td  class="animalKattaDesc" style="font-size:22px;font-weight:bold;color:white;">8</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </b-card-text>
        </b-card>
      </div>
      <div
        class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6"
        style="height: 200px"
      >
        <b-card style="max-width: 20rem" class="mb-2">
          <b-card-text @click="oxDetails">
            <img
              src="../assets/ox.jpg"
             
              style="width:150px;height:160px;object-fit: cover; padding: 5px"
            />
            <div class="centered">
                <div class="row center_back">
                  <div
                    class="col-12"
                    style="
                      font-family: Arial;
                      font-size: 18px;
                      padding: 5px;
                    "
                  >
                    <table>
                      <tr >
                        <td  class="animalKattaDesc" style="font-size:20px;font-weight:bold;color:white">ox</td> <td  class="animalKattaDesc" style="font-size:22px;font-weight:bold;color:white;">5</td>
                      </tr>
                    </table>
                  </div>
                </div>

              </div>
          </b-card-text>
        </b-card>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6">
        <b-card style="max-width: 20rem" class="mb-2">
          <b-card-text @click="goatDetails">
            <img
              src="../assets/111.jpg"
              style="width:150px;height:160px;object-fit: cover; padding: 5px"
            />
            <div class="centered">
                <div class="row center_back">
                  <div
                    class="col-12"
                    style="
                      font-family: Arial;
                      font-size: 18px;
                      padding: 5px;
                    "
                  >
                    <table>
                      <tr >
                        <td  class="animalKattaDesc" style="font-size:22px;font-weight:bold;color:white;">Goat</td> <td  class="animalKattaDesc" style="font-size:22px;font-weight:bold;color:white;">8</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
          </b-card-text>
        </b-card>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6">
        <b-card style="max-width: 20rem" class="mb-2">
          <b-card-text @click="buffeloDetails">
            <img
              src="../assets/123.jpg"
              style="width:150px;height:160px;object-fit: cover; padding: 5px"
            />
            <div class="centered">
                <div class="row center_back">
                  <div
                    class="col-12"
                    style="
                      font-family: Arial;
                      font-size: 18px;
                      padding: 5px;
                    "
                  >
                    <table>
                      <tr >
                        <td  class="animalKattaDesc" style="font-size:22px;font-weight:bold;color:white;">Buffalo</td> <td  class="animalKattaDesc" style="font-size:22px;font-weight:bold;color:white;">10</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
          </b-card-text>
        </b-card>
      </div>
    </div><br/>
    <div class="row">
      <div class="col-12">
          <b-btn
          block
          class="btn-success animalKattaDesc"
          style="text-align: center"
          @click="inquiry()"
        >
          Sell Inquiry Received </b-btn>
      </div>
    </div>
    <br />
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabIndex: 0,
    };
  },
  methods: {
    inquiry(){
       this.$router.push("/inquirylist");
    },
    back() {
      this.$router.go("-1");
    },
    view() {
      this.$router.push("/buyer");
    },
    add() {
      this.$router.push("/add_animal");
    },
    handleDetails() {
      this.$router.push("/cowdetails");
    },
    handleDoctor() {
      this.$router.push("/home/nearby_doctor");
    },
    handleCertificate() {
      this.$router.push("/transportcertificate");
    },
    handleProfile() {
      this.$router.push("/farmer_profile");
    },
    oxDetails() {
      this.$router.push("/oxdetails");
    },
    goatDetails() {
      this.$router.push("/goatdetails");
    },
    buffeloDetails() {
      this.$router.push("/buffelodetails");
    },
    cowdetails() {
      this.$router.push("/Cowviewdetails");
    },
    Oxdetails() {
      this.$router.push("/Oxviewdetails");
    },
    Goatdetails() {
      this.$router.push("/Goatviewdetails");
    },
    Buffelodetails() {
      this.$router.push("/Buffeloviewdetails");
    },
    
  },
};
</script>
<style scoped>
.container {
  position: relative;
  text-align: center;
  color: black;
}
.center_back{
  width:130px;
  padding-right: 10px;
  padding:0px;
  margin:0px;
  padding-top:0px;
  background: rgba(0, 0, 0, 0.5);
}
.centered {
  position: absolute;
  font-size: 20px;
  top: 85%;
  left: 50%;
  font-weight: bold;
  transform: translate(-50%, -50%);
}
.card-body {
    padding: 0rem !important;
}
</style>
